import { RichTextBaseExtensions } from '@framework/form/inputs/rich-text/RichTextBaseExtensions.tsx';
import { ComputeExpressionReferenceNode } from '../../schema/expressions/compute/input/nodes/ComputeExpressionReferenceNode.tsx';
import { TooltipVirtualNode } from './render/nodes/TooltipVirtualNode.tsx';

export const RichTextAdvancedExtensions = [
  ComputeExpressionReferenceNode.configure({}),
];

export const RichTextAdvancedRenderingExtensions = [
  ...RichTextBaseExtensions,
  ...RichTextAdvancedExtensions,
  TooltipVirtualNode,
];
